import React from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';




let Shipping = () => {

   let shipping = [
      {
         pluginImage: "/assets/images/shipping/tcs.png",
         title: "TCS",
         pluginKey: "",
         description: "Leading courier and logistics company offering reliable and efficient services.",
         status: true,
      },
      {
         pluginImage: "/assets/images/shipping/fedex.webp",
         title: "FedEx",
         pluginKey: "",
         description: "Reliable and fast shipping services worldwide with real-time tracking.",
         status: true,
      },
      {
         pluginImage: "/assets/images/shipping/dhl.png",
         title: "DHL",
         pluginKey: "",
         description: "International express deliveries; global freight forwarding by air, sea, road, and rail.",
         status: true,
      },
      {
         pluginImage: "/assets/images/shipping/leopards.png",
         title: "Leopards",
         pluginKey: "",
         description: "Comprehensive logistics and courier services with a focus on customer satisfaction.",
         status: true,
      },

   ];

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Shipping Methods</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="bg-white p-3 overflow-hidden">
                        <div className="d-flex justify-content-between border-bottom  pb-2">
                           <div>
                              <h4>Shipping Methods</h4>
                           </div>
                        </div>
                        <br />
                        <div className="row">
                           <div className="col-12">
                              <p className="text-muted" style={{ fontSize: "1rem" }}>
                                 We are enhancing our shipping methods to provide you with more options. Stay tuned for exciting updates!
                              </p>
                           </div>
                        </div>
                        <div className="row">
                           {shipping?.map((data, index) => {
                              return (
                                 <div key={index} className="col-12 mb-1">
                                    <div className="plugin-card p-2 border rounded d-flex">
                                       <img src={data.pluginImage} alt={data.title} className="img-fluid" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }} />
                                       <div className="ms-4 w-100">
                                          <h5 className="plugin-title mb-2">{data.title}</h5>
                                          <p className="plugin-description mb-2">{data.description}</p>
                                          {/* <span className={`badge ${data.status ? 'bg-success' : 'bg-secondary'}`}>
                                                {data.status ? 'Active' : 'Inactive'}
                                             </span> */}
                                          <p className="text-muted text-end mt-1" style={{ fontSize: "1rem", fontWeight: "bold", color: "#ff5733" }}>Coming Soon</p>
                                       </div>
                                    </div>
                                 </div>
                              )
                           })}
                        </div>
                     </div>
                     <br />
                  </div>
               </div>
            </div>
         </DashboardLayout>
      </>
   )
}

export default Shipping